import { DownOutlineIcon, VOutlineIcon } from '@carboncopyco/icons';
import type { DemoLinkAccessPolicy } from '@carboncopyco/types';
import { TextBase } from '@carboncopyco/ui';
import classNames from 'classnames';
import { demoLinkAccessPolicyTypes } from './consts';

type DemoLinkAccessPolicyItemProps = {
  disabled?: boolean;
  accessPolicy: DemoLinkAccessPolicy;
} & (
  | { isSelected: boolean; variant?: 'option' }
  | { isSelected?: never; variant?: 'trigger' }
);

export const DemoLinkAccessPolicyItem = ({
  accessPolicy,
  variant = 'option',
  isSelected = false,
  disabled,
}: DemoLinkAccessPolicyItemProps) => {
  const dsColor =
    !disabled && variant === 'option'
      ? 'text-ds-natural-600'
      : 'text-ds-primary';

  return (
    <div
      className={classNames(
        'py-3 px-5 flex items-center justify-between rounded-lg',
        {
          'bg-ds-natural-50': !disabled || variant === 'trigger',
        }
      )}
    >
      <div className="flex items-center gap-4">
        <div className="flex flex-col items-start">
          <div className={classNames('flex items-center gap-2', dsColor)}>
            <TextBase
              color={dsColor}
              label={demoLinkAccessPolicyTypes[accessPolicy].label}
            />
            <div className="h-6">
              {!disabled && variant === 'trigger' && <DownOutlineIcon />}
            </div>
          </div>
          <TextBase
            label={demoLinkAccessPolicyTypes[accessPolicy].description}
          />
        </div>
      </div>
      {isSelected && <VOutlineIcon size={30} />}
    </div>
  );
};
